import { ReactElement } from "react";
import { Navigate } from "react-router-dom";
import { TailSpin } from "react-loader-spinner";
import { useAuth } from "../context/AuthContext";

export function AdminRoute({ children }: { children: ReactElement }): ReactElement {
    const { isLoading, isAuthenticated, user } = useAuth();

    if (isLoading) {
        return (
            <div className="flex items-center justify-center min-h-screen bg-[#F4F5F7]">
                <TailSpin color="rgb(17,58,40)" height={80} width={80} />
            </div>
        );
    }

    if (!isAuthenticated) {
        return <Navigate to="/login?mode=login" replace />;
    }

    if (!user?.is_admin) {
        return <Navigate to="/library" replace />;
    }

    return children;
}
